import React from 'react';
import './LoyaltyLevel.css';
import { FaChevronDown } from 'react-icons/fa';
import moonStarsIcon from "assets/img/moonStarsIcon.png";
import PropTypes from 'prop-types';

class LoyaltyLevel extends React.Component {
  render() {
    const { level, nights, bookings_total, max_nights_level } = this.props;
    const accumulatedNights = Number(nights) || 0;
    const accumulatedBookings = Number(bookings_total) || 0;
    const nightsRequired = Number(max_nights_level) || 0;
    const remainingNights = Math.max(0, nightsRequired - accumulatedNights);
    const progressPercentage = nightsRequired > 0
      ? Math.min((accumulatedNights / nightsRequired) * 100, 100)
      : 0;

    return (
      <div className="loyalty-level-container">
        {/* Nuevo elemento para el contador de noches con luna */}
        <div className="nights-counter">
          <span className="nights-number">{accumulatedNights}</span>
          <img src={moonStarsIcon} alt="Icono Nights" className="moon-icon" />
        </div>

        {/* Título y nivel */}
        <div className="loyalty-header">
          <span className="loyalty-title">{this.context.t('YOUR LEVEL')}</span>
          <span className="loyalty-level">Sandos4u {level}</span>
        </div>

        {/* Noches y barra de progreso */}
        <div className="nights-section">
          <div className="progress-bar">
            <div
              className="progress"
              style={{ width: `${progressPercentage}%` }}
            ></div>
            <div
              className="progress-marker"
              style={{ left: `${progressPercentage}%` }}
            >
              <span className="marker-nights">{accumulatedNights} {this.context.t('Nights')}</span>
              <FaChevronDown className="chevron-icon" />
            </div>
          </div>
        </div>

        {/* Detalles adicionales */}
        <div className="details-section">
          <div className="level-details">
            <span className="level-name">{level}</span>
            <span className="level-description">{accumulatedNights} {this.context.t('Nights')}/{accumulatedBookings} {this.context.t('Bookings')}</span>
          </div>
          <div className="level-stats">
            <span className="stat-text">Gold</span>
            <span className="stat-value">{remainingNights} {this.context.t('Nights')}</span>
            <span className="stat-note">({this.context.t('in the last 2 years')})</span>
          </div>
        </div>
      </div>
    );
  }
}

LoyaltyLevel.propTypes = {
  level: PropTypes.string,
  nights: PropTypes.number,
  bookings_total: PropTypes.number,
  max_nights_level: PropTypes.number,
};

LoyaltyLevel.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default LoyaltyLevel;
